import { primaryColor } from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';

type Props = {
  onClick?: () => void,
  fllColor?: string,
  disableHover?: boolean,
} & typeof defaultProps;

const defaultProps = {
  onClick: () => { },
  fllColor: '#1EC252',
  disableHover: false
};
const SVG = styled.svg<{ disableHover?: boolean }>`
  ${({ disableHover }) =>
    !disableHover &&
    `
    &:hover {
      path {
        fill: ${primaryColor};
      }
    }
  `}
`;

const NotesIcon = function NotesIcon({ onClick, fllColor, disableHover }: Props) {
  return (
    <SVG width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg"
      className="notes-icon-svg" onClick={onClick} disableHover={disableHover}>
      <path d="M9.92683 3.13854C9.92683 2.97985 9.80341 2.87405 9.66235 2.87405H3.08553C2.92684 2.87405 2.82104 2.99748 2.82104 3.13854V4.28463C2.82104 4.44332 2.94447 4.54912 3.08553 4.54912H9.66235C9.82104 4.54912 9.92683 4.42569 9.92683 4.28463V3.13854Z" fill={fllColor} />
      <path d="M9.66235 5.97731H3.08553C2.92684 5.97731 2.82104 6.10074 2.82104 6.24179V7.38789C2.82104 7.54658 2.94447 7.65237 3.08553 7.65237H9.66235C9.82104 7.65237 9.92683 7.52895 9.92683 7.38789V6.24179C9.92683 6.10074 9.80341 5.97731 9.66235 5.97731Z" fill={fllColor} />
      <path d="M2.82104 9.36269V10.5088C2.82104 10.6675 2.94447 10.7909 3.08553 10.7909H8.19887C8.25177 10.3325 8.42809 9.89166 8.72784 9.53901L9.09812 9.09821H3.08553C2.92684 9.08058 2.82104 9.22163 2.82104 9.36269Z" fill={fllColor} />
      <path d="M8.00503 12.7834L8.05793 12.1662H1.44584V1.44584H11.3552V6.4005L12.2368 5.3602C12.3955 5.16624 12.5894 5.00755 12.801 4.8665V0.987405C12.801 0.440806 12.3426 0 11.796 0H0.987405C0.440806 0 0 0.440806 0 0.987405V12.607C0 13.1536 0.440806 13.5944 0.987405 13.5944H8.07556C8.00503 13.33 7.96977 13.0478 8.00503 12.7834Z" fill={fllColor} />
      <path d="M16.398 7.52895L14.6877 6.10074C14.4761 5.92442 14.2293 5.83626 13.9472 5.87152C13.6827 5.88916 13.4358 6.03021 13.2595 6.22417L9.76833 10.403C9.62727 10.5617 9.55674 10.7557 9.53911 10.9672L9.36278 12.9068C9.32752 13.2418 9.46858 13.5592 9.71543 13.7708C9.89175 13.9295 10.1386 14 10.3678 14C10.456 14 10.5441 13.9823 10.6323 13.9647L12.519 13.4534C12.7129 13.4005 12.8892 13.2947 13.0303 13.136L16.5391 8.95716C16.8741 8.53399 16.8212 7.8816 16.398 7.52895ZM11.9371 12.0075L10.9497 12.2897L11.0378 11.267L14.0882 7.61711L14.9875 8.3753L11.9371 12.0075Z" fill={fllColor} />
    </SVG>
  );
};
NotesIcon.defaultProps = defaultProps;
export default NotesIcon;
